
const push = (obj) => {
  window.dataLayer && window.dataLayer.push(obj)
}

const pushPageContext = (type, path, layout) => {
  push({
    page: {
      type,
      path,
      layout
    }
  })
}

const pushUserContext = (jforceId, jumiaId) => {
  push({
    user: {
      jforceId,
      jumiaId
    }
  })
}

const pushEvent = (category, subCategory, action, label, value, event) => {
  push({
    eventContent: {
      category,
      subCategory,
      action,
      label,
      value
    },
    event
  })
}

const pushJForceEvent = (category, subCategory, action, label) => {
  pushEvent(category, subCategory, action, label, 0, 'jforce')
}

const pushErrorEvent = (category, subCategory, action, label) => {
  pushEvent(category, subCategory, action, label, 0, 'error')
}

const pushScreenOpenedEvent = (name, path) => {
  pushJForceEvent('Screen', name, 'Opened', path)
}

const pushButtonClickedEvent = (name, path) => {
  pushJForceEvent('Button', name, 'Clicked', path)
}

const pushLinkClickedEvent = (name, path) => {
  pushJForceEvent('Link', name, 'Clicked', path)
}

const pushCardClickedEvent = (name, path) => {
  pushJForceEvent('Card', name, 'Clicked', path)
}

const pushFilterAppliedEvent = (name, path) => {
  pushJForceEvent('Filter', name, 'Applied', path)
}

const pushAppErrorEvent = (action, label) => {
  pushErrorEvent('error', 'application', action, label)
}

const pushApiErrorEvent = (action, label) => {
  pushErrorEvent('error', 'api', action, label)
}

export {
  pushScreenOpenedEvent,
  pushButtonClickedEvent,
  pushLinkClickedEvent,
  pushCardClickedEvent,
  pushFilterAppliedEvent,

  pushPageContext,
  pushUserContext,

  pushAppErrorEvent,
  pushApiErrorEvent
}
